module.exports = __webpack_public_path__ + "img/OBUHomePage_03.e8c3e13e.png";